export default "__VITE_ASSET__B_l2wzGv__"